import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { StoreRequestSearch } from '../../../../../models/api-store/store/store.request.model';
import { RolesRequestList } from '../../../../../models/api-user/roles/roles.request.model';
import { RolesResourceEnum } from '../../../../../models/roles.resource';
import { UsersRequest, UsersRequestStore } from '../../../../../models/users/users.request.model';
import { StoreService } from '../../../../../services/api-store/store/store.service';
import { RolesService } from '../../../../../services/api-user/roles/roles.service';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { UserService } from '../../../../../services/user/user.service';
import { FALSE, TRUE } from '../../../../../utils/config/const';


@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {

  @Input() public id: number;
  formBuilder: FormGroup;
  request: any = {};
  response:any = null;
  isButtonSaveDisabled: boolean;
  roles: any = [];
  stores: any = [];
  currentUser: any;

  isVisibleSectionStore: boolean = false;
  roleSelected:string="";
  private rolesResource = RolesResourceEnum;

  oldMail: string = "";
  isVisibleMsg: boolean = false;
  avvisoMSG: string = "Dopo il salvataggio il tuo account verrà disconnesso e dovrai effettuare il login per rendere effettive le modifiche!";


  saveObj:any = {
    user:null,
    removeStores:null,
    addStores:null
  }



  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private spinner: SpinnerService,
    private userService: UserService,
    private rolesService: RolesService,
    private storeService: StoreService,
    private toastr: ToastrService,
    public auth: AuthenticationService,
    public router: Router
  ) {
    this.initForm();

  }

  ngOnInit(): void {
    this.currentUser = this.auth.currentUserValue;
    this.loadRoles();
    this.loadDataByID(this.id);
    this.loadStores(this.id);
  }

  loadRoles() {
    this.spinner.show();
    let request = new RolesRequestList();
    request.pageNumber = 0;
    request.pageSize = 50;
    this.rolesService.getList(request).subscribe(
      (response) => {
        if (response) {
          this.roles = response.data;
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni del header', 'Load header', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }




  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }

  loadDataByID(idObj) {
    this.userService.getEntity(idObj).subscribe(
      (response) => {
        if (response) {
          this.oldMail = response.email;
          this.setFormValue(response);
          if (response.role != null) {
            if (response.role.length > 0) {
              this.changeRoleByName(response.role[0].name);
            }
          }
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni del header', 'Load header', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  initForm() {
    this.formBuilder = this.fb.group({
      name: ['', [Validators.required]],
      surname: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      role: ['', [Validators.required]],
      enabled: [true, [Validators.required]],
      note: ['']
    });
    this.isButtonSaveDisabled = false;
  }

  getFormValue() {
    let request = new UsersRequest();
    request.email = this.formBuilder.controls['email'].value;
    request.enabled = this.formBuilder.controls['enabled'].value;
    request.name = this.formBuilder.controls['name'].value;
    request.note = this.formBuilder.controls['note'].value;

    let roleObj = null;
    for (let role of this.roles) {
      if (this.formBuilder.controls['role'].value == role.id) {
        roleObj = role;
      }
    }
    if (roleObj != null) {
      request.role = [];
      request.role.push(roleObj);
    }
    request.surname = this.formBuilder.controls['surname'].value;
    return request;
  }



  getRemoveStores(){
    let request = new UsersRequestStore();
    request.listaStores = [];
    for (let store of this.stores) {
      if(store['del'] === TRUE){
        request.listaStores.push(store.id);
      }
    }
    return request;
  }

  getAddStores(){
    let request = new UsersRequestStore();
    request.listaStores = [];
    for (let obj of this.storeSelect_Selected) {
      request.listaStores.push(obj.id);
    }
    return request;
  }

  setFormValue(response) {
    this.formBuilder.controls['email'].setValue(response.email);
    this.formBuilder.controls['enabled'].setValue(response.enabled);
    this.formBuilder.controls['name'].setValue(response.name);
    this.formBuilder.controls['note'].setValue(response.note);
    this.formBuilder.controls['role'].setValue("");
    if (response.role != null) {
      if (response.role.length > 0) {
        this.formBuilder.controls['role'].setValue(response.role[0].id);
        this.roleSelected = response.role[0].name;
      }
    }
    this.formBuilder.controls['surname'].setValue(response.surname);


    this.formBuilder.valueChanges.subscribe(val => {
      if (this.currentUser.email === this.oldMail) {
        this.isVisibleMsg = true;
      }
    });
  }

  checkSave(){
    if(
        this.saveObj.user == TRUE &&
        this.saveObj.removeStores == TRUE &&
        this.saveObj.addStores == TRUE){
          this.toastr.success('Modificato con successo', 'Modifica utente');
          if (this.isVisibleMsg === FALSE) {
            this.isButtonSaveDisabled = true;
            this.activeModal.close(this.response);
          } else {
            //loggout and redirect
            this.auth.logout();
            this.activeModal.close('CLOSE');
            this.router.navigate(['login']);
          }
        }
  }


  save() {
    this.request = this.getFormValue();
    let removeStores = this.getRemoveStores();
    let addStores = this.getAddStores();

    //Rimozione stores utente
    if(removeStores.listaStores.length > 0){
      this.userService.removeStore(this.id,removeStores).subscribe(
        (response) => {
          if(response){
            //Salvato
            this.saveObj.removeStores = true;
            this.checkSave();
          }
        },
        (error: HttpErrorResponse) => {
          this.saveObj.removeStores = false;
          this.isButtonSaveDisabled = false;
          this.toastr.error('Si è verificato un errore durante la rimozione degli store' , 'Modifica store utente fallita', {
              timeOut: 5000
          });
          this.checkSave();
        }
      );
    }else{
      this.saveObj.removeStores = true;
    }

    //Aggiunta store utente
    if(addStores.listaStores.length > 0 && this.isVisibleSectionStore == TRUE){
      this.userService.addStore(this.id,addStores).subscribe(
        (response) => {
          if(response){
            //Salvato
            this.saveObj.addStores = true;
            this.checkSave();
          }
        },
        (error: HttpErrorResponse) => {
          this.saveObj.addStores = false;
          this.isButtonSaveDisabled = false;
          this.toastr.error('Si è verificato un errore durante la rimozione degli store' , 'Modifica store utente fallita', {
              timeOut: 5000
          });
          this.checkSave();
        }
      );
    }else{
      this.saveObj.addStores = true;
    }


    this.userService.update(this.id, this.request).subscribe(
      (response) => {
        if (response) {
          //Salvato
          this.saveObj.user = true;
          this.response = response;
          this.checkSave();
        }
      },
      (error: HttpErrorResponse) => {
        this.saveObj.user = false;
        this.isButtonSaveDisabled = false;
        this.toastr.error('Si è verificato un errore durante la modifica', 'Modifica utente fallita', {
          timeOut: 5000
        });
      }
    );
  }


  changeRole() {
    let roleID = this.formBuilder.controls['role'].value;
    let roleName = "";
    for (let role of this.roles) {
      if (role.id === parseInt(roleID)) {
        roleName = role.name;
      }
    }
    if (roleName != null && typeof roleName != typeof undefined && roleName != "") {
      if (roleName !== this.rolesResource.ROLE_ADMIN.split("_")[1] && roleName !== this.rolesResource.ROLE_NOOVLE.split("_")[1] && roleName !== this.rolesResource.ROLE_STORES_UPLOAD_MANAGER.split("ROLE_")[1]) {
        this.isVisibleSectionStore = true;
        this.roleSelected = roleName;
        this.storeSelect_Selected = [];
      } else {
        this.isVisibleSectionStore = false;
      }
    } else {
      this.isVisibleSectionStore = false;
    }
  }

  changeRoleByName(roleName) {
    if (roleName != null && typeof roleName != typeof undefined && roleName != "") {
      if (roleName !== this.rolesResource.ROLE_ADMIN.split("_")[1] && roleName !== this.rolesResource.ROLE_NOOVLE.split("_")[1] && roleName !== this.rolesResource.ROLE_STORES_UPLOAD_MANAGER.split("ROLE_")[1]) {
        this.isVisibleSectionStore = true;
      } else {
        this.isVisibleSectionStore = false;
      }
    } else {
      this.isVisibleSectionStore = false;
    }
  }





  clickButtonSave() {
    if (this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE) {
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }



  //Gestione store associati e da associare

  loadStores(idUser) {
    this.userService.store(idUser).subscribe(
      (response) => {
        if (response) {
          this.stores = response;
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni degli store associati all\'utente', 'Load store', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  clickButtonGoToStore(id) {
    const url = 'store/store/' + id;
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
    this.clickButtonCancel();
  }

  clickButtonChangeDelStore(id, val) {
    let indexToRemove = -1;
    for (let i = 0; i < this.stores.length && indexToRemove == -1; i++) {
      if (this.stores[i].id === id) {
        indexToRemove = i;
        this.stores[i].del = val;
      }
    }
  }



  //Autocomplete - storeSelect
  @ViewChild('storeSelect') storeSelect;
  storeSelect_Keyword = 'titleSeo';
  storeSelect_Suggestion: any = [];
  storeSelect_Selected: any = [];
  storeSelect_errorMsg: string;
  storeSelect_isKeywordLoadingResult: boolean;

  getFilter_storeSelect(event) {
    let request = new StoreRequestSearch();
    request.q = event;
    request.pageNumber = 0
    request.pageSize = 20
    if(this.roleSelected != ""){
      let tempRole = this.roleSelected;
      switch(tempRole){
        case 'STOREMANAGER_FRANCHISING':request.dealerCategory = "FRANCHISING"; break;
        case 'STOREMANAGER_FLAGSHIP_MONOBRAND':request.dealerCategory = "MONOBRAND"; break;
        case 'STOREMANAGER_GDS':request.dealerCategory = "GDS";break;
        case 'STOREMANAGER_MULTIBRAND':request.dealerCategory = "EXCELLENT,MASTER,STANDARD,FW_POINTS";break;
        case 'STOREMANAGER_SUPERVISOR':break;
        case 'ADMIN':break;
        case 'NOOVLE':break;
      }
    }
    return request
  }

  searchIdOnStores(id){
    let trovato = false;
    for (let store of this.stores) {
      if (id == store.id) {
        trovato = true;
        break;
      }
    }
    return trovato;
  }

  searchIdOnStoreSelect(id){
    let trovato = false;
    for (let storeSelect of this.storeSelect_Selected) {
      if (id == storeSelect.id) {
        trovato = true;
        break;
      }
    }
    return trovato;
  }

  fillSuggestion_store(response){
    if (response.data.length > 0) {
      //aggiungo elementi nella suggestion
      for (let obj of response.data) {
        let trovato = false;
        if(this.searchIdOnStores(obj.id) == TRUE || this.searchIdOnStoreSelect(obj.id) == TRUE){
          trovato = true;
        }
        if (!trovato) {
          this.storeSelect_Suggestion.push(obj);
        }
      }
    }
  }
  getList_storeSelect(event) {
    this.storeSelect_isKeywordLoadingResult = true;
    let request = this.getFilter_storeSelect(event);
    this.storeService.search(request).subscribe(response => {
      this.storeSelect_Suggestion = [];
      if(response != null && typeof response != typeof undefined){
        this.fillSuggestion_store(response);
      }
      this.storeSelect_isKeywordLoadingResult = false;
    });
  }
  searchCleared__storeSelect() {
    this.storeSelect_Suggestion = [];
  }
  selectEvent__storeSelect(item) {
    this.isButtonSaveDisabled = false;
    this.storeSelect_Selected.push(item);
    this.storeSelect.clear();
  }
  onFocused__storeSelect(e) {
    this.getList_storeSelect("");
    // do something when input is focused
  }
  //Chip list - storeSelect
  labelKeys_storeSelect = ["titleSeo"];
  onChangeItemList_storeSelect($event) {
    if ($event != null) {
      if ($event.length > 0) {
        this.isButtonSaveDisabled = false;
      } else {
        this.isButtonSaveDisabled = true;
      }
    } else {
      this.isButtonSaveDisabled = true;
    }
  }



}
